module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp1_1.81bd6894.png";